/* eslint-disable react/no-array-index-key */
import React, { Fragment } from 'react';
import { css } from '@emotion/core';
import { Observer } from 'mobx-react';
import VoucherColumn from './columns/VoucherColumn';
import DealColumn from './columns/DealColumn';
import DtvtColumn from './columns/DtvtColumn';
import { useRootStore } from '../../stores/BridgeProvider';
import Spinner from '../util/Spinner';

const FlexStuff = css`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const NoData = css`
  color: #666;
  margin-top: 3rem;
  font-size: 1.3rem;
`;

const RenderTable = ({ dealMap, index, isLast }) => (
  <Observer
    render={() => {
      const { deals, vouchers, dtvts } = dealMap;

      return (
        <div
          css={FlexStuff}
          style={{
            marginTop: index > 0 ? '1rem' : 'inherit',
            paddingBottom: isLast && '90px',
          }}
          key={index}
        >
          <DealColumn dealsWithDealTransactions={deals} />
          <DtvtColumn dtvts={dtvts} />
          <VoucherColumn vouchersWithVoucherTransactions={vouchers} />
        </div>
      );
    }}
  />
);

const DealMapTable = () => (
  <Observer
    render={() => {
      const { dealMapperStore } = useRootStore();
      if (dealMapperStore.loading) return <Spinner />;

      const dealMapSections =
        dealMapperStore.dealMapperViewStore.dealMapForView;

      if (!dealMapSections) {
        return <Spinner />;
      }

      const numberOfSections = dealMapSections.length;

      if (numberOfSections === 0)
        return <div css={NoData}>Select a voucher or deal to begin</div>;

      return dealMapSections.map((s, i) => (
        <RenderTable
          dealMap={s}
          key={i}
          index={i}
          isLast={numberOfSections - 1 === i}
        />
      ));
    }}
  />
);

export default DealMapTable;
